<mat-card>
    <div fxLayout="row wrap">
        <div fxFlex="100" fxFlex.gt-sm="50" class="p-2">
            <h2 class="text-muted text-center">Sign In</h2>
            <form [formGroup]="loginForm" (ngSubmit)="onLoginFormSubmit(loginForm.value)">
                <mat-form-field appearance="outline" class="w-100 mt-2">
                    <mat-label>Email</mat-label>
                    <input type="email" matInput #loginEmailId placeholder="Email" formControlName="email_id" required>
                    <mat-error *ngIf="loginForm.controls.email_id.errors?.required">Email is required</mat-error>
                    <mat-error *ngIf="loginForm.controls.email_id.hasError('invalidEmail')">Invalid email address</mat-error>
                    <mat-error *ngIf="loginForm.controls.email_id.hasError('validation')">
                        {{loginForm.controls.email_id.errors.message}}                    
                    </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100 mt-1">
                    <mat-label>Password</mat-label>
                    <input type="password" matInput placeholder="Password" formControlName="password" required>
                    <mat-error *ngIf="loginForm.controls.password.errors?.required">Password is required</mat-error>
                    <mat-error *ngIf="loginForm.controls.password.hasError('minlength')">Password isn't long enough, minimum of 6 characters</mat-error>
                    <mat-error *ngIf="loginForm.controls.password.hasError('validation')">
                        {{loginForm.controls.password.errors.message}}                    
                    </mat-error>
                </mat-form-field> 
                <section class="example-section">
                    <mat-checkbox class="example-margin" color = "primary" formControlName="rememberMe">Remember Me</mat-checkbox>
                  </section>
                <div class="text-center mt-2">
                    <button mat-fab color="primary" class="mat-elevation-z6" [disabled]="isLoadingSignInBtn"
                    [ngClass]="{'routeworx-spinner spinner-style3': isLoadingSignInBtn}">
                        <i class="material-icons" data-icon="exit_to_app"></i>                        
                    </button>
                </div> 

                <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-3">
                    <div class="divider w-100"></div>
                    <a [routerLink]="['/forgot-password']" class="text-muted auth">
                        or Forgot Password
                    </a>
                    <div class="divider w-100"></div>
                </div> 
            </form>
            
        </div>
        <div fxFlex="100" fxFlex.gt-sm="50" class="p-2" ngClass.sm="mt-2" ngClass.xs="mt-2">
            <div class="CreateNewAcc">
                <h3>NEW CUSTOMER</h3>
                <p>By creating an account with us, you will be able to move through the checkout process faster and view your orders.</p>
                <button routerLink="/sign-up"><mat-icon>account_circle</mat-icon>Create an Account</button>
            </div>    
        </div>
    </div> 
</mat-card>
